export default "__VITE_ASSET__CdAY_P$R__"